export default __webpack_public_path__ + "static/media/influencer-3.b6f81177.png";